import { ReactElement } from "react";
import cx from "classnames";

import { AdUnit, type AdUnitProps } from "./AdUnit";

export type AdvertisementProps = {
  rootClassName?: string;
  adUnitProps: AdUnitProps;
  setAdsHeight?: React.Dispatch<React.SetStateAction<number>>;
};

/**
 * This component renders an ad.
 * @param rootClassName - The root class name.
 * @param type - The type of the ad.
 * @param adUnitProps - The props for the ad.
 * @see https://www.imsph.sg/advertising-solutions/digital/imu/
 * @returns
 */
export default function Advertisement({
  rootClassName = "",
  adUnitProps,
  setAdsHeight,
}: AdvertisementProps): ReactElement {
  return (
    <div
      ref={(e) => {
        if (setAdsHeight && e) {
          setAdsHeight(e.scrollHeight);
        }
      }}
      className={cx("text-center", rootClassName)}
      data-testid="advertisement-element"
    >
      <AdUnit {...adUnitProps} />
    </div>
  );
}
